import { debounce } from 'lodash'

export default {
    data: () => ({
        windowWidth: window.innerWidth,
    }),
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    methods: {
        breakpointDown(size) {
            return this.windowWidth < this.bootstrapBreakpoint(size)
        },
        breakpointUp(size) {
            return this.windowWidth >= this.bootstrapBreakpoint(size)
        },
        onResize: debounce(function() {
            this.windowWidth = window.innerWidth
        }, 100),
        bootstrapBreakpoint(size) {
            const style = window.getComputedStyle(document.body)
            return parseInt(style.getPropertyValue(`--breakpoint-${size}`).slice(0, -2))
        },
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize())
    },
}
